import i18n from "@/lang/locale";

export class Translator {
    public translateAnswerOption(answerOption: string): string {
        return !!i18n.messages[i18n.locale]['components.' + answerOption]
            ? i18n.messages[i18n.locale]['components.' + answerOption].toString()
            : answerOption;
    }
}